export default __webpack_public_path__ + "static/media/bg-check-in.59a85d35.svg";